import { Banner, Icon, spacing } from '@scality/core-ui';
import { Box, Button } from '@scality/core-ui/dist/next';
import { useChat } from '../../hooks/useChat';

/**
 * A failed turn (isError message): danger banner instead of the markdown +
 * feedback pipeline. Retry only shows on the last message — retryLastMessage
 * drops the trailing message, which must be this error.
 */
export const ErrorMessageCard: React.FC<{ message: string; isLastResponse: boolean }> = ({
  message,
  isLastResponse,
}) => {
  const { retryLastMessage } = useChat();

  return (
    <Box display="flex" flexDirection="column" gap={spacing.r8}>
      <Banner variant="danger" withDefaultIcon>
        {message}
      </Banner>
      {isLastResponse && (
        <Box display="flex" justifyContent="end">
          <Button variant="outline" label="Retry" icon={<Icon name="Sync" />} onClick={retryLastMessage} />
        </Box>
      )}
    </Box>
  );
};
